import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchSortBy } from '@uncinc/react-searchkit';
import type { SearchSortByProps } from '@uncinc/react-searchkit/dist/components/SortBy';

import { APP_OPTIONS } from '../../../config/constants';

import './style.scss';

const SearchAllContentSortBy: React.FC<Omit<SearchSortByProps, 'items'>> = ({ className, ...restProps }) => {
  const { t } = useTranslation();

  return (
    <SearchSortBy
      {...restProps}
      inputType="radios"
      className={c('SearchAllContent__SortBy', className)}
      items={[
        {
          label: t('components.search.sort.date'),
          value: `${APP_OPTIONS.parameters.searchkitIndexAllContent}_created`,
        },
        {
          label: t('components.search.sort.relevance'),
          value: APP_OPTIONS.parameters.searchkitIndexAllContent,
        },
      ]}
    />
  );
};

export default SearchAllContentSortBy;
